import React from 'react';
import { useTranslation } from 'react-i18next';

export default function TOS() {
  const { t } = useTranslation();

  return (
    <div className="bg-white text-gray-900 px-6 py-16 max-w-4xl mx-auto mt-12">
      <h1 className="text-3xl font-bold mb-6">{t('tos.heading')}</h1>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">{t('tos.introduction.heading')}</h2>
        <p className="text-lg leading-7">{t('tos.introduction.content')}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">{t('tos.usage.heading')}</h2>
        <p className="text-lg leading-7">{t('tos.usage.content')}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">{t('tos.account.heading')}</h2>
        <p className="text-lg leading-7">{t('tos.account.content')}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">{t('tos.privacy.heading')}</h2>
        <p className="text-lg leading-7">{t('tos.privacy.content')}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">{t('tos.termination.heading')}</h2>
        <p className="text-lg leading-7">{t('tos.termination.content')}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">{t('tos.changes.heading')}</h2>
        <p className="text-lg leading-7">{t('tos.changes.content')}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">{t('tos.contact.heading')}</h2>
        <p className="text-lg leading-7">{t('tos.contact.content')}</p>
      </section>
    </div>
  );
}
